/**
 * @flow
 * @relayHash f7075c10f1ec2df978eca01106724f58
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteShipmentItemInput = {|
  id: string
|};
export type DeleteShipmentItemMutationVariables = {|
  input: DeleteShipmentItemInput
|};
export type DeleteShipmentItemMutationResponse = {|
  +deleteShipmentItem: {|
    +deletedId: string
  |}
|};
export type DeleteShipmentItemMutation = {|
  variables: DeleteShipmentItemMutationVariables,
  response: DeleteShipmentItemMutationResponse,
|};
*/


/*
mutation DeleteShipmentItemMutation(
  $input: DeleteShipmentItemInput!
) {
  deleteShipmentItem(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteShipmentItemInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteShipmentItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteShipmentItemPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteShipmentItemMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteShipmentItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteShipmentItemMutation",
    "id": null,
    "text": "mutation DeleteShipmentItemMutation(\n  $input: DeleteShipmentItemInput!\n) {\n  deleteShipmentItem(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'edd88c0d0fbb115227124bf2146270eb';
module.exports = node;
